export const DEFAULT_CHECK = 'x100';
export const DOCUMENT_ATTRIBUTE_CHECK = 'x101';
export const DOCUMENT_CHECK = 'x102';
export const HEADLESS_CHROME_CHECK = 'x103';
export const LANGUAGES_CHECK = 'x104';
export const WEBDRIVER_CHECK = 'x105';
export const WINDOW_CHECK = 'x106';
// export const WEBDRIVER_PROTOTYPE_OVERRIDES_CHECK = 'x107';
